<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useOAuthStore } from '../../model/oauth/store'
import { useOAuthApi } from '../../api/oauth/get.hook'
import CardOAuthConnection from './CardOAuthConnection.vue'

defineOptions({
  name: 'OAuthConnections',
})

const ZOHO_TOKEN_KEY = 'zoho_oauth_token_data'

const store = useOAuthStore()
const { getGoogle: refGoogle, getZoho: refZoho } = storeToRefs(store)

const refresh = (): void => {
  void useOAuthApi()
}
</script>

<template>
  <div class="oauth-connections">
    <CardOAuthConnection
      v-for="category in refGoogle"
      :key="category.id"
      :title="`Google — ${category.title}`"
      :token-id="category.id"
      :connection="category.oauth"
      @disconnected="refresh"
    />
    <CardOAuthConnection
      v-if="refZoho"
      title="Zoho"
      :token-id="ZOHO_TOKEN_KEY"
      :connection="refZoho"
      @disconnected="refresh"
    />
  </div>
</template>

<style scoped lang="scss" src="./OAuthConnections.scss" />
